/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestions_Prompt_1Inputs */

const es_chat_suggestions_prompt_1 = /** @type {(inputs: Chat_Suggestions_Prompt_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar mis correos recientes`)
};

const en_chat_suggestions_prompt_1 = /** @type {(inputs: Chat_Suggestions_Prompt_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search my recent emails`)
};

/**
* | output |
* | --- |
* | "Search my recent emails" |
*
* @param {Chat_Suggestions_Prompt_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_prompt_1 = /** @type {((inputs?: Chat_Suggestions_Prompt_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Prompt_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_prompt_1(inputs)
	return en_chat_suggestions_prompt_1(inputs)
});
export { chat_suggestions_prompt_1 as "chat.suggestions.prompt_1" }